/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { signOut } from '@ghq-abi/auth-client-lib/client';

import { oprApi } from '~/shared/services/api';

import { GetFeatureFlagsAPIResponse } from './useGetFeatureFlags';

async function clearDataAndSignOut() {
  if (typeof window !== 'undefined') {
    localStorage.clear();
    sessionStorage.clear();
    document.cookie.split(';').forEach(cookie => {
      const [name] = cookie.split('=');
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    });

    if ('caches' in window) {
      caches.keys().then(names => {
        names.forEach(name => caches.delete(name));
      });
    }
  }

  await signOut({
    redirect: false,
  });
}

export async function fetchFeatureFlags(): Promise<Record<string, boolean>> {
  try {
    const response = await oprApi.get<GetFeatureFlagsAPIResponse>(
      'feature-flag-management/access-control',
      {}
    );

    if (response.status === 401) {
      await clearDataAndSignOut();
    }

    if (response.data?.length) {
      return response.data?.reduce((acc, curr) => {
        return {
          ...acc,
          [curr.name]: curr.status,
        };
      }, {});
    }

    return {};
  } catch (error: any) {
    console.log(
      '[Feature Flags] - Error trying to fetch feature flags - Status:',
      error.response?.status
    );
    if (error.response?.status === 401) {
      await clearDataAndSignOut();
    }
    return {};
  }
}
